/*=========================================================================================
  File Name: moduleTypologyMutations.js
  Description: Typology Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_TIPOLOGY(state, tipology) {
		state.tipologies.unshift(tipology);
	},
	SET_TIPOLOGIES(state, tipologies) {
		state.tipologies = tipologies;
	},
	SET_DESCRIPTION(state, data) {
		state.tipologies[data.index].description = data.new_escription;
	},
	UPDATE_TIPOLOGY(state, tipology) {
		const tipologyIndex = state.tipologies.findIndex((p) => p.id === tipology.id);
		Object.assign(state.tipologies[tipologyIndex], tipology);
	},
	REMOVE_TIPOLOGY(state, itemId) {
		const ItemIndex = state.tipologies.findIndex((t) => t.id === itemId);
		state.tipologies.splice(ItemIndex, 1);
	},
};
